import {
    faDoorClosed,
    faEdit,
    faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import {
    AtualizarEtapaController,
    GetEtapaController,
} from "../../../../../../../../../../Controllers/Geral/Etapas/EtapasControllers";
import { IEtapa } from "../../../../../../../../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import SliderInput from "../../../../../../../../../CardsPages/Forms/SliderInput";
import SpinnerComponent from "../../../../../../../../../Loding/Spinner";

interface IGeralEtapaProps {
    idEtapa: number;
    lstEtapas: Array<IEtapa>;

    updateList: () => void;
}

export default function GeralEtapa(props: IGeralEtapaProps) {
    const { register, handleSubmit } = useForm();

    const [etapa, setEtapa] = useState<IEtapa>();

    useEffect(() => {
        GetEtapaController(props.idEtapa).then(setEtapa);
    }, [props.idEtapa]);

    function handleEtapaFormSubmit(formData: IEtapa) {
        AtualizarEtapaController({
            DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                formData.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
            NR_SLO: formData.NR_SLO,
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: props.idEtapa,
            NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                formData.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
        }).then(props.updateList);
    }

    return !etapa ? (
        <SpinnerComponent />
    ) : (
        <form
            className="form-row"
            onSubmit={handleSubmit(handleEtapaFormSubmit)}
        >
            {etapa.FL_ETAPA_INICIAL && (
                <div className="col-12 d-flex justify-content-end">
                    <span className="label abel-pill label-inline label-info">
                        <FontAwesomeIcon icon={faStar} className="mr-2" /> Etapa
                        Inicial
                    </span>
                </div>
            )}
            {etapa.FL_ETAPA_FINAL && (
                <div className="col-12 d-flex justify-content-end">
                    <span className="label abel-pill label-inline label-primary">
                        <FontAwesomeIcon icon={faDoorClosed} className="mr-2" />{" "}
                        Etapa Final
                    </span>
                </div>
            )}
            <div className="col-12 col-md-6">
                <label>Nome da Etapa</label>
                <input
                    className="form-control"
                    name="DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                    ref={register()}
                    defaultValue={
                        etapa.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                    }
                />
            </div>
            <div className="col-12 col-md-6">
                <label>SLO ( em horas )</label>
                <input
                    className="form-control"
                    name="NR_SLO"
                    defaultValue={etapa.NR_SLO}
                    type="number"
                    ref={register()}
                />
            </div>
            {!etapa.FL_ETAPA_FINAL && !etapa.FL_ETAPA_INICIAL && (
                <div className="col-12 col-md-6">
                    <label>Ordem</label>
                    <SliderInput
                        className="form-control"
                        name="NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                        defaultValue={
                            etapa.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                        }
                        type="range"
                        min={2}
                        max={
                            props.lstEtapas[props.lstEtapas.length - 1]
                                .NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO - 1
                        }
                        ref={register({
                            valueAsNumber: true,
                        })}
                    />
                </div>
            )}

            <div className="col-12 mt-5">
                <button className="w-100 btn btn-success">
                    Atualizar <FontAwesomeIcon icon={faEdit} className="ml-2" />
                </button>
            </div>
        </form>
    );
}
